import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { TrainingMaterialFileDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { FileViewer, File as FileViewerFile } from 'modules/trainings/components/Files/FileViewer'

export default function TrainingMaterialFileViewer() {
  const { trainingId, fileId, fileType } = useParams<{
    trainingId: string
    fileId: string
    fileType: string
  }>()
  const { navigation } = useNavigation()
  const { data, loading, error } = useQuery(TrainingMaterialFileDocument, {
    variables: {
      trainingId: Number(trainingId),
    },
  })

  if (loading) return null
  if (error) throw error

  const trainingFiles = data?.trainings?.trainingFilesConnection?.nodes ?? []
  const trainingClassFiles = data?.trainings?.trainingClassFilesConnection?.nodes ?? []

  const files: FileViewerFile[] = []
  for (const file of trainingFiles) {
    files.push({
      id: file.id,
      filename: file.filename,
      title: file.title,
      contentType: file.contentType,
      url: file.url,
      type: 'training' as const,
    })
  }
  for (const file of trainingClassFiles) {
    files.push({
      id: file.id,
      filename: file.filename,
      title: file.title,
      contentType: file.contentType,
      url: file.url,
      type: 'trainingClass' as const,
    })
  }

  // Sort files by title (fallback to filename)
  files.sort((a, b) => ((a.title || a.filename) > (b.title || b.filename) ? 1 : -1))

  const currentFile = files.find((f) => f.id === Number(fileId) && f.type === fileType)
  if (!currentFile) throw new Error(`File with ID ${fileId} not found in training ${trainingId}.`)

  return (
    <FileViewer
      file={currentFile}
      files={files}
      urlBackTo={navigation.myTrainings.revamp.detailsRevamp.view.materials.fullPath({
        trainingId: trainingId || '',
      })}
      goNextFile={(nextFileInViewer: FileViewerFile): string => {
        if (nextFileInViewer && nextFileInViewer.id) {
          return navigation.myTrainings.revamp.detailsRevamp.view.materials.file.fullPath({
            trainingId: trainingId || '',
            fileId: String(nextFileInViewer.id),
            fileType: nextFileInViewer.type,
          })
        }
        return '#'
      }}
      goPrevFile={(prevFileInViewer: FileViewerFile): string => {
        if (prevFileInViewer && prevFileInViewer.id) {
          return navigation.myTrainings.revamp.detailsRevamp.view.materials.file.fullPath({
            trainingId: trainingId || '',
            fileId: String(prevFileInViewer.id),
            fileType: prevFileInViewer.type,
          })
        }
        return '#'
      }}
    />
  )
}
